/**
 * @generated SignedSource<<0942948e1259b79678fd5e1f0d85665f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Type = "PRAISE" | "REQUESTED" | "UNSOLICITED";
import { FragmentRefs } from "relay-runtime";
export type MoreActions_item$data = {
  readonly context: ReadonlyArray<{
    readonly __typename: "User";
    readonly firstName: string;
    readonly fullName: string;
    readonly id: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  }>;
  readonly creator: {
    readonly id: string;
  } | null;
  readonly id: string;
  readonly isDraft: boolean;
  readonly isThreeSixtyParent: boolean;
  readonly recipients: ReadonlyArray<{
    readonly user: {
      readonly id: string;
    };
  }>;
  readonly requests: ReadonlyArray<{
    readonly feedbackRecord: {
      readonly id: string;
    } | null;
    readonly id: string;
  }>;
  readonly sharedWithMe: boolean;
  readonly type: Type;
  readonly " $fragmentType": "MoreActions_item";
};
export type MoreActions_item$key = {
  readonly " $data"?: MoreActions_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"MoreActions_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MoreActions_item",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDraft",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sharedWithMe",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isThreeSixtyParent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "creator",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "context",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fullName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            }
          ],
          "type": "User",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FeedbackRequestNode",
      "kind": "LinkedField",
      "name": "requests",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "FeedbackRecordNode",
          "kind": "LinkedField",
          "name": "feedbackRecord",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FeedbackRecipientNode",
      "kind": "LinkedField",
      "name": "recipients",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FeedbackNode",
  "abstractKey": null
};
})();

(node as any).hash = "98f74decaecdb1d3478128f859f6d0ca";

export default node;
